import { Component, OnInit } from '@angular/core';
import { ModelsOutOfStockService } from 'src/app/services/reports/models-out-of-stock.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-models-out-of-stock',
  templateUrl: './models-out-of-stock.component.html',
  styleUrls: ['./models-out-of-stock.component.css']
})
export class ModelsOutOfStockComponent implements OnInit{
  public errorMessage: string | null = null;
  public warningMessage: string | null = null;
  report_data: any[] = [];
  public isInProgress: boolean = false;

  constructor(
    private modelsOutOfStockService: ModelsOutOfStockService,
  ){

  }

  ngOnInit(): void {
    this.isInProgress=true;
    this.fetchReportData();
  }

  fetchReportData():void{
    this.modelsOutOfStockService.getData()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.report_data = response.data;
          this.isInProgress=false;
        }else if(response.status==='no_data'){
           this.warningMessage=response.message;
           this.isInProgress=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
      }
    });
  }

  exportToPdf() {
    const pdf = new jsPDF('p', 'mm', 'a4');
    // Add report title before the table
    pdf.setFontSize(14);
    pdf.text('Models Out Of Stock Report', 105, 15, { align: 'center' });

    // Render table below the title
    autoTable(pdf, {
      html: '#example1', // <-- the ID of your bootstrap table
      theme: 'striped',
      startY: 25, // push table down so it doesn't overlap the title      // or 'grid', 'plain'
      headStyles: { fillColor:  [40, 167, 69], textColor: 255 }, // custom header color
      styles: { fontSize: 10, cellPadding: 3 },
      didDrawPage: (data) => {
        // Footer
        const pageCount = pdf.getNumberOfPages();
        const pageSize = pdf.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

        // Page number (centered bottom)
        pdf.setFontSize(10);
        pdf.text(
          `Page ${pdf.getCurrentPageInfo().pageNumber} of ${pageCount}`,
          pageSize.width / 2,
          pageHeight - 10,
          { align: 'center' }
        );

        // Generated date (left bottom)
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January = 0
        const yyyy = today.getFullYear();

        let hours = today.getHours();
        const minutes = String(today.getMinutes()).padStart(2, '0');
        const seconds = String(today.getSeconds()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // 0 becomes 12 in 12hr format

        const formattedDate = `${dd}-${mm}-${yyyy}`;
        const formattedTime = `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;

        pdf.text(
          `Generated On: ${formattedDate} ${formattedTime}`,
          10,
          pageHeight - 10
        );
      },
    });

    pdf.save('models-out-of-stock.pdf');
  }
}
